import './style.scss'
import { useContext, useEffect, useRef, useState } from "react";
import ApiContext from 'src/provider/API/call-service';
import UserContext from 'src/provider/state-manager/userProvider';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import { AbsoluteContainer, AppLabel, AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, GridContainer, ScreenTitle, Switch } from "src/style";
import { SidePopupLayout, ConfirmTransfer, TxPinVerification, TransferCompleted, ScheduleTransfer, Beneficiaries, Banks, AuthOtp } from "src/component";
import { FiChevronDown } from "react-icons/fi";
import { HiOutlineUser } from 'react-icons/hi'
import helpers, { getDateDifferenceInDays } from 'src/utils/helpers';
import { Features, IExpenseCategory, ITransfer } from 'src/model';
import utility, { handleAmountChange, handleTypeNumberControl, moneyFormat } from 'src/utils/utility';
import { useDetectWrap, useIntersection } from 'src/hooks';
//import { expenseCategories } from 'src/provider/config/constant';

const initialState: ITransfer = {
    senderAccount: '', amount: '', beneficiaryAccount: '', expenseCategory: 'General', senderName: '',
    remarks: '', frequency: '', startDate: '', endDate: '', beneficiaryBank: '', canSaveBeneficiary: false,
    beneficiaryName: '', beneficiaryBankCode: '', pin: '', shouldSaveBeneficiary: false, reminder: '',
    nipSession: ''
}

export const MakeTransfer: React.FC<any> =({close}) => {
    const {notifier} = useContext(VisibilityContext)
    const {user: {accountInfo, accountWithBalanceDetails, dashboardData}} = useContext(UserContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const {API} = useContext(ApiContext)
    const [navPosition, setNavPosition] = useState(0)
    const [fetchedBanks, setFetchBanks] = useState<any>(null)
    const [input, setInput] = useState({...initialState})
    const [transferType, setTransferType] = useState('')
    const [isScheduleTransfer, setIsScheduleTransfer] = useState(false)
    const [view, setView] = useState('make-transfer')
    const [otherBenAcct, setOtherBenAcct] = useState('')
    const [transactionReference, setTransactionReference] = useState('')
    const [expenseCategories, setExpenseCategories] = useState<IExpenseCategory[]>([])
    const [isLoading, setIsLoading] = useState(false)
    const [isWrapped, setIsWrapped] = useState(false)
    const [amount, setAmount] = useState("")
    const onResizeWrapped = useDetectWrap('account-resolve-item', 77)
    const paymentItemIsHidden = institutionData?.paymentItemIsHidden;
    const accountNumberLength = institutionData?.accountNumberLength;
    const maxLength = (accountNumberLength === 0) || (accountNumberLength === null) ? 10 : accountNumberLength
    console.log('accountNumberLength', maxLength);

    const wrapRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (accountWithBalanceDetails?.length === 1) {
            setInput({...input, senderAccount: accountWithBalanceDetails[0].nuban || accountWithBalanceDetails[0].number})
        }
    }, [accountWithBalanceDetails, input.senderAccount])

    useEffect(() => {
        checkWrap()
    }, [input.canSaveBeneficiary, onResizeWrapped])

    async function checkWrap () {
        // This method is to detect when 'account-resolve-item' class
        // has wrapped and to set the alignItems of the second child GridContainer to start.
        // This method can be improved on without the use of "wait" method from utility 
        await utility.wait(50)
        if (wrapRef.current?.clientHeight) setIsWrapped(wrapRef.current.clientHeight > 77)
    }

    useEffect(() => {
        handleFetchExpenseCategories()
    }, [])

    async function handleFetchExpenseCategories() {
        setIsLoading(true)
        const response = await API.getExpenseCategories()
        setIsLoading(false)
        if (response) setExpenseCategories(response)
    }

    function handleTransferType (e: React.ChangeEvent<HTMLSelectElement>) {
        //setNavPosition(val)
        if (e) setTransferType(e.target.value)
        setInput(initialState)
    }

    const handleInput = async (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        let [bankName, acctName, canSaveBeneficiary, reminder] = [input.beneficiaryBank, input.beneficiaryName, input.canSaveBeneficiary, input.reminder]
        if (e.target.name === 'beneficiaryAccount') {
            if (e.target.value.length === maxLength) {
                if (transferType === '2') {
                    setOtherBenAcct(e.target.value)
                    setIsLoading(true)
                    const response = await API.getBanks(e.target.value)
                    setIsLoading(false)
                    if (response) {
                        setFetchBanks(response)
                        setView('banks')
                    }
                }
                else if (transferType === '1') {
                    setIsLoading(true)
                    const response = await API.nameInquirySameBank(e.target.value, input.senderAccount)
                    setIsLoading(false)
                    if (response) {
                        acctName = response.accountName
                        bankName = institutionData?.name || ''
                        e.target.value = response.accountNumber
                        canSaveBeneficiary = true
                    }
                    else e.target.value = ''
                }
                else if (transferType === '0') {
                    acctName = helpers.getAccountDetailsWithAcctNo(accountInfo, e.target.value).accountName
                }
            }
            else [bankName, acctName, canSaveBeneficiary] = ['', '', false]
        }
        if (e.target.name === 'startDate') {
            if (getDateDifferenceInDays(e.target.value) <= 1) reminder = '0'
            else reminder = ''
        }

        setInput({
            ...input, 
            reminder,
            [e.target.name]: e.target.value, 
            beneficiaryBank: bankName, 
            beneficiaryName: acctName,
            canSaveBeneficiary
        })
    }

    const handleRemarksInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>)=>{
        const {name, value} = e.target;
        const sanitizedValue = value.replace(/[^a-zA-Z0-9\s,.-/]/g, '');
        setInput({
            ...input,
            [name]: sanitizedValue,
        });
    }

    // const handleAmount = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     let val = e.target.value.replace(/[,.]/g, '')
    //     if (!isNaN(Number(val))) {
    //         setInput({...input, amount: val})
    //     }
    // }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        if (input.beneficiaryAccount.length != maxLength) return notifier.show('Kindly provide a valid destination account number')
        const {isValidated, message} = helpers.validateTxAmount(accountWithBalanceDetails, input.senderAccount, Number(input.amount))
        if (!isValidated) return notifier.show(message, 'Validation Response')
        
        if (isScheduleTransfer) setView('schedule-transfer')
        else setView('confirm-transfer')
    }

    async function handleSubmit () {
        const payload = {...input, amount: String(input.amount)}
        if (transferType === '0') payload.isSelfTransfer = true
        if (isScheduleTransfer) {
            payload.transferType = Number(transferType)
            if (input.frequency == '1') payload.endDate = payload.startDate
        }

        payload.accountTier = Number(helpers.getAccountDetailsWithAcctNo(dashboardData, payload.senderAccount)?.accountBalance?.accountTier)

        const response = isScheduleTransfer ?
            await API.scheduleTransfer(payload)
            : transferType === '2' ? 
            await API.interbankTransfer(payload)
            : await API.intrabankTransfer(payload)

        if (response) {
            setTransactionReference(response.reference)
            if (!response.shouldUseOtp) setView('success-transfer')
            else setView('2fa-otp')
        }
        else setView('make-transfer')
    }

    async function handleSubmitWithAuth (otp: string) {
        const payload = {
            reference: transactionReference,
            shouldSaveBeneficiary: input.shouldSaveBeneficiary,
            nipSession: input.nipSession,
            otp
        }

        const response = !isScheduleTransfer ? 
            await API.submitTransferWithAuth(payload) 
            : await API.submitScheduleTransferWithAuth(payload)
        if (response) {
            if (!isScheduleTransfer) setTransactionReference(response.reference)
            setView('success-transfer')
        }
        else setView('make-transfer')
    }
    
    return (
        <>
            { view === 'make-transfer' &&
                <SidePopupLayout close={close}>
                    { (isLoading) &&
                        <AbsoluteContainer top='0' left='0' zIndex='3' width='100' sizeUnit='%' height="full">
                            <GridContainer height='100' hUnit="%" bgColor='rgba(255, 255, 255, 0.5)'>
                                <AppSpan textSize='4' color='#0D968F' className='fa fa-spinner fa-spin' />
                            </GridContainer>
                        </AbsoluteContainer>
                    }
                    <ScreenTitle textSize="2.2" fontWeight="700">Make Transfer</ScreenTitle>
                    {/* <GridContainer 
                        height="3.6" topMargin="3" bottomMargin="2.5" 
                    >
                        <AbsoluteContainer width='33.3' sizeUnit="%" top="0" left={`${navPosition}`} lSizeUnit='%'>
                            <CustomContainer bgColor="#E7F6F5" height="3.6" radius="0.6" />
                        </AbsoluteContainer>
                        <FlexRow zIndex="2">
                            <AppSpan 
                                color={navPosition === 0 ? "#0A756F" : "#667085"}
                                textSize="1.4" cursor="pointer" fontWeight='600'
                                width='33.3' sizeUnit='%' align='center'
                                onClick={() => handleTransferType(0)}
                            >
                                Self
                            </AppSpan>
                            <AppSpan 
                                color={navPosition === 33.3 ? "#0A756F" : "#667085"}
                                textSize="1.4" cursor="pointer" fontWeight='600'
                                width='33.3' sizeUnit='%' align='center'
                                onClick={() => handleTransferType(33.3)}
                            >
                                {institutionData?.name}
                            </AppSpan>
                            <AppSpan 
                                color={navPosition === 66.6 ? "#0A756F" : "#667085"}
                                textSize="1.4" cursor="pointer" fontWeight='600'
                                width='33.3' sizeUnit='%' align='center'
                                onClick={() => handleTransferType(66.6)}
                            >
                                Others
                            </AppSpan>
                        </FlexRow>
                    </GridContainer> */}
                    <Form 
                        onSubmit={handleProceed}
                        style={{height: '87%'}}
                        className='overflow-y-container'
                    >
                        <FormGroupWithIcon topMargin="3" bottomMargin='2'>
                            <label>Transfer Type</label>
                            <div className='input-with-icon'>
                                <select 
                                    value={transferType}
                                    style={{color: transferType ? '#000000' : '#667085'}}
                                    onChange={handleTransferType}
                                    required
                                >
                                    <option value="">Select Transfer Type</option>
                                    <option 
                                        value="0"
                                        disabled={!institutionData.featureIDs?.includes(Features.INTRA_BANK_TRANSFER)}
                                    >
                                        To Self
                                    </option>
                                    <option 
                                        value="1"
                                        disabled={!institutionData.featureIDs?.includes(Features.INTRA_BANK_TRANSFER)}
                                    >
                                        To {institutionData?.name}
                                    </option>
                                    <option 
                                        value="2"
                                        disabled={!institutionData.featureIDs?.includes(Features.INTER_BANK_TRANSFER)}
                                    >
                                        To Other Banks
                                    </option>
                                </select>
                                <FiChevronDown className="input-with-icon-tag" />
                            </div>
                        </FormGroupWithIcon>
                        <FormGroupWithIcon bottomMargin='2'>
                            <label>Select Source Account</label>
                            <div className='input-with-icon'>
                                <select 
                                    name='senderAccount'
                                    value={input.senderAccount}
                                    style={{color: input.senderAccount ? '#000000' : '#667085'}}
                                    onChange={handleInput}
                                    disabled={accountWithBalanceDetails?.length === 1}
                                    required
                                >
                                    <option value="">Select Account</option>
                                    {
                                        accountWithBalanceDetails?.map((item: any, index: number) => {
                                            return (
                                                <option 
                                                    value={item.nuban || item.number}
                                                    key={index}
                                                    disabled={(item.nuban || item.number) === input.beneficiaryAccount}
                                                >
                                                    {item.nuban || item.number} - ({moneyFormat(item?.balance?.withdrawableAmount,false,institutionData?.defaultCurrency)})
                                                </option>
                                            )
                                        })
                                    }
                                </select>
                                <FiChevronDown className="input-with-icon-tag" />
                            </div>
                        </FormGroupWithIcon>
                        <FormGroup>
                            <label>Amount</label>
                            <input 
                                placeholder='Enter Amount' 
                                name='amount'
                                autoComplete='off'
                                value={amount}
                                onChange={(e) => handleAmountChange(e.target.value,"input",setAmount, setInput,input,e.target.name)}
                                required
                            />
                        </FormGroup>
                       { transferType === '0' &&
                            <FormGroupWithIcon bottomMargin='2'>
                                <label>Select Destination Account</label>
                                <div className="input-with-icon">
                                    <select 
                                        placeholder="Destination Account"
                                        name='beneficiaryAccount'
                                        value={input.beneficiaryAccount}
                                        style={{color: input.beneficiaryAccount ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        required
                                    >
                                        <option value="">Select Account</option>
                                        {
                                            accountWithBalanceDetails?.map((item: any, index: number) => {
                                                return (
                                                    <option 
                                                        value={item.nuban || item.number}
                                                        key={index}
                                                        disabled={(item.nuban || item.number) === input.senderAccount}
                                                    >
                                                        {item.nuban || item.number} - ( {moneyFormat(item?.balance?.withdrawableAmount,false,institutionData?.defaultCurrency)})
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                       }
                        { transferType != '0' &&
                            <CustomContainer bottomMargin="2">
                                <AppLabel 
                                    fontWeight="600" color="#1A2C37" bottomPadding="0.8"
                                    noThemeColor
                                >
                                    Account Number
                                </AppLabel>
                                <FlexRow justifyContent="space-between">
                                    <FormGroup className="custom-input-with-icon">
                                        <input 
                                            placeholder='Enter Account Number' 
                                            type='number'
                                            name='beneficiaryAccount'
                                            value={input.beneficiaryAccount}
                                            onChange={handleInput}
                                            onKeyDown={handleTypeNumberControl}
                                            onKeyUp={handleTypeNumberControl}
                                            autoComplete="off"
                                            required
                                        />
                                    </FormGroup>
                                    <GridContainer 
                                        width="4.4" height="4.8" bgColor="#E7F6F5" borderColor="#E7F6F5"
                                        className='custom-input-icon hoverable-icon-container'
                                        hoverBgColor='#B4E3E1'
                                        onClick={() => setView('beneficiaries')}
                                    >
                                        <AppSpan textSize="2.1" color="#0A756F"><HiOutlineUser /></AppSpan>
                                    </GridContainer>
                                </FlexRow>
                            </CustomContainer>
                        }
                        { !input.canSaveBeneficiary &&
                            <>
                                { (input.beneficiaryName && input.beneficiaryBank) &&
                                    <FormGroup>
                                        <label>Destination Bank</label>
                                        <input 
                                            name='beneficiaryBank'
                                            value={input.beneficiaryBank}
                                            onChange={handleInput}
                                            autoComplete="off"
                                            disabled
                                            required
                                        />
                                    </FormGroup>
                                }
                                { input.beneficiaryName &&
                                    <FormGroup>
                                        <label>Destination Account Name</label>
                                        <input 
                                            name='beneficiaryName'
                                            value={input.beneficiaryName}
                                            onChange={handleInput}
                                            autoComplete="off"
                                            disabled
                                            required
                                        />
                                    </FormGroup>
                                }
                            </>
                        }
                        { input.canSaveBeneficiary && 
                            <CustomContainer bottomMargin='2'>
                                <CustomContainer
                                    minHeight="7.7" borderColor="#E7F6F5" padding="1.5" 
                                    radius="0.8" bgColor="#E7F6F5"
                                    className='account-resolve-item' 
                                    ref={wrapRef}
                                >
                                    <FlexRow justifyContent="space-between" gap="1.5" wrap="wrap">
                                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                                            <AppSpan>Account Name</AppSpan>
                                            <AppText fontWeight="700" color="#0D968F" fontFamily='Gilmer-Semi-Bold'>{input.beneficiaryName}</AppText>
                                        </GridContainer>
                                        <GridContainer 
                                            width="auto" sizeUnit=""
                                            alignItems={(isWrapped)? "start" : "end"}
                                        >
                                            <AppSpan>Bank</AppSpan>
                                            <AppText fontWeight="700" color="#0D968F" fontFamily='Gilmer-Semi-Bold'>{input.beneficiaryBank}</AppText>
                                        </GridContainer>
                                    </FlexRow>
                                </CustomContainer>
                                <FlexRow gap="1" topMargin='1.5' alignItems="flex-start">
                                    <Switch
                                        radius='1.17' bgColor='#F2F4F7' 
                                        checkedBgColor='#0D968F' checkedSliderBgColor="#ffffff"
                                    >
                                        <input 
                                            type="checkbox" 
                                            checked={input.shouldSaveBeneficiary}
                                            onChange={(e) => setInput({...input, shouldSaveBeneficiary: e.target.checked})} />
                                        <div ></div>
                                        <span></span>
                                    </Switch>
                                    <AppText fontWeight="600" color="#344054">Save Beneficiary</AppText>
                                </FlexRow>
                            </CustomContainer>
                        }
                        {!paymentItemIsHidden && <FormGroupWithIcon bottomMargin='2'>
                            <label>Expense Category</label>
                            <div className="input-with-icon">
                                <select 
                                    placeholder="Select Expense Category"
                                    name='expenseCategory'
                                    value={input.expenseCategory}
                                    style={{color: input.expenseCategory ? '#000000' : '#667085'}}
                                    onChange={handleInput}
                                    //required
                                >
                                    <option value="Select">Select Category</option>
                                    {
                                        expenseCategories?.map((item: IExpenseCategory, index: number) => {
                                            return <option value={item.name} key={index}>{item.name}</option>
                                        })
                                    }
                                </select>
                                <FiChevronDown className="input-with-icon-tag" />
                            </div>
                        </FormGroupWithIcon>}
                        <FormGroup>
                            <label>Transaction remarks</label>
                            <textarea 
                                placeholder='Enter a remarks...' 
                                name='remarks'
                                value={input.remarks}
                                onChange={handleRemarksInput}
                                required
                                maxLength={50}
                            />
                        </FormGroup>
                        <FlexRow gap="1" alignItems="flex-start">
                            <Switch
                                radius='1.17' bgColor='#E7E7E7' 
                                checkedBgColor='#0D968F' checkedSliderBgColor="#ffffff"
                            >
                                <input 
                                    type="checkbox" 
                                    checked={isScheduleTransfer}
                                    onChange={(e) => setIsScheduleTransfer(e.target.checked)} />
                                <div ></div>
                                <span></span>
                            </Switch>
                            <CustomContainer width="auto" sizeUnit="" topMargin="-0.2">
                                <AppText fontWeight="600" color="#344054" topPadding="0">Schedule Transfer</AppText>
                                <AppSpan color="#667085" topMargin="-0.5">This feature enables recurring transfers</AppSpan>
                            </CustomContainer>
                        </FlexRow>
                        <FlexRow justifyContent='flex-end'>
                            <Button 
                                width='8.8' height='4' topMargin='2.5' 
                                borderColor='#0D968F' hoverBgColor='#fff' 
                                hoverColor='#0D968F' titleSize='1.4'
                            >
                                Proceed
                            </Button>
                        </FlexRow>
                    </Form>
                </SidePopupLayout>
            }
            { view === 'confirm-transfer' &&
                <ConfirmTransfer
                    close={close}
                    data={{...input, transferType}} 
                    next={() => setView('pin')}
                    back={() => setView('make-transfer')}
                />
            }
            { view === 'pin' &&
                <TxPinVerification
                    close={() => setView('make-transfer')}
                    onPinChange={(pin: string) => setInput({...input, pin})}
                    next={handleSubmit} 
                />
            }
            { view === '2fa-otp' &&
                <AuthOtp
                    close={close}
                    next={handleSubmitWithAuth} 
                />
            }
            { view === 'success-transfer' &&
                <TransferCompleted
                    data={{...input, transactionReference, transferType, isScheduleTransfer}}
                    close={close}
                />
            }
            { view === 'schedule-transfer' &&
                <ScheduleTransfer
                    formData={input}
                    handleInput={handleInput}
                    next={() => setView('pin')}
                    close={close} 
                />
            }
            { view === 'beneficiaries' &&
                <Beneficiaries
                    close={() => setView('make-transfer')}
                    formData={{...input, transferType}}
                    handleSelect={setInput}
                    next={() => setView('make-transfer')}
                />
            }
            { view === 'banks' &&
                <Banks
                    close={close}
                    formData={{...input, beneficiaryAccount: otherBenAcct}}
                    handleSelect={setInput}
                    bankData={fetchedBanks}
                    next={() => setView('make-transfer')}
                />
            }
        </>
    )
}